module.exports = __webpack_public_path__ + "media/images/element/26-caded56597e3ba6efdff187286e926c6.svg";